import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    customType: String,
    fieldName: String,
    updateUrl: String
  };

  async cancel(event) {
    event.preventDefault();

    try {
      await this.sendSaveRequest("");
      window.location.reload();
    } catch (error) {
      console.error("Error cancelling custom request:", error);
      alert(`An error occurred while cancelling: ${error.message}`);
    }
  }

  async sendSaveRequest(valueToSave) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

    if (!csrfToken) {
      throw new Error("CSRF token not found");
    }

    const response = await fetch(this.updateUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        custom_request: {
          custom_type: this.customTypeValue,
          field_name: this.fieldNameValue,
          field_value: valueToSave
        }
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.errors?.join(", ") || "Failed to save");
    }

    const data = await response.json();

    if (!data.success) {
      throw new Error(data.errors?.join(", ") || "Failed to save");
    }

    return data;
  }
}
